import { useEffect, useRef, useState } from 'react';
import * as antIcon from '@ant-design/icons';
import { Button, notification } from 'antd';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';

// services
import * as ActivityService from '../../../../../services/bb-api/activity';

// components
import { ImageTool } from '../../../../shared/image-tool';

import { txt } from '../../../../../locales/i18n';

export function ImageTab({ useActivity }: any): JSX.Element {
	const [imageSource, setImageSource] = useState<string>('');
	const [activity, setActivity] = useActivity;
	const imageToolRef = useRef<any>(null);
	const params: any = useParams<any>();
	const activityId: number = params.id;

	useEffect(() => {
		async function getImage(): Promise<void> {
			try {
				const image: string = await ActivityService.getImage(activityId);
				setImageSource(image);
			} catch (error) {
				notification.error({ message: 'Error getting image' });
			}
		}

		getImage();
	}, [activityId]);

	async function handleUpdateImage(): Promise<void> {
		let base64: string;

		try {
			const canvas = imageToolRef.current.getImage();
			base64 = canvas.toDataURL('image/jpeg');
		} catch (error) {
			notification.error({ message: 'Image invalid' });
			return;
		}

		try {
			const imgFilename: string = await ActivityService.updateImage(activityId, base64);
			notification.success({ message: 'Successful update' });
			setActivity({ ...activity, imgFilename });
		} catch (error) {
			notification.error({ message: 'Image update failed' });
		}
	}

	return (
		<Container>
			<ImageTool imageSource={imageSource} setImageSource={setImageSource} refProxy={imageToolRef} />

			<div>
				<Button type="primary" onClick={handleUpdateImage} icon={<antIcon.CheckOutlined />}>
					{txt('global.update')}
				</Button>
			</div>
		</Container>
	);
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;

	.ant-slider {
		margin: 0.6rem;
	}
`;
